// components/FileUploadArea.jsx
import React, { useRef, useEffect, useState } from 'react';
import { FileTextIcon } from '../common/IconsComponent';

const FileUploadArea = ({ selectedFile, fileInputKey, onFileChange, onRemoveFile, onUpload }) => {
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);
  const dropAreaRef = useRef(null);

  // Drag and drop handlers
  useEffect(() => {
    const dropArea = dropAreaRef.current;
    if (!dropArea) return;

    const handleDragOver = (e) => {
      e.preventDefault();
      e.stopPropagation();
      setIsDragging(true);
    };

    const handleDragLeave = (e) => {
      e.preventDefault();
      e.stopPropagation();
      setIsDragging(false);
    };

    const handleDrop = (e) => {
      e.preventDefault();
      e.stopPropagation();
      setIsDragging(false);
      
      const files = e.dataTransfer.files;
      if (files.length) {
        onFileChange(files[0]);
      }
    };

    dropArea.addEventListener('dragover', handleDragOver);
    dropArea.addEventListener('dragleave', handleDragLeave);
    dropArea.addEventListener('drop', handleDrop);

    return () => {
      if (dropArea) {
        dropArea.removeEventListener('dragover', handleDragOver);
        dropArea.removeEventListener('dragleave', handleDragLeave);
        dropArea.removeEventListener('drop', handleDrop);
      }
    };
  }, [onFileChange]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      onFileChange(file);
    }
  };

  return (
    <div>
      <label className="block text-sm font-medium mb-1">בחר קובץ PDF</label>
      <div 
        ref={dropAreaRef}
        className={`border border-dashed border-blue-300 rounded p-4 flex flex-col items-center justify-center ${
          isDragging ? 'bg-blue-50' : selectedFile ? 'bg-green-50 border-green-300' : ''
        }`}
        style={{ minHeight: '80px' }}
      >
        {selectedFile ? (
          <div className="flex flex-col items-center w-full">
            <FileTextIcon className="text-green-500 mb-2" size={24} />
            <p className="text-center mb-2">{selectedFile.name}</p>
            <div className="flex justify-center space-x-2 space-x-reverse">
              <button 
                className="bg-red-100 text-red-600 px-2 py-1 rounded text-sm"
                onClick={onRemoveFile}
              >
                הסר
              </button>
              <button 
                className="bg-blue-600 text-white px-4 py-1 rounded hover:bg-blue-700 text-sm"
                onClick={onUpload}
              >
                שלח
              </button>
            </div>
          </div>
        ) : (
          <>
            <p className="text-gray-500 mb-2 text-center">גרור ושחרר קובץ PDF לכאן</p>
            <p className="text-gray-500 mb-2 text-center">או</p>
            <button 
              className="bg-blue-100 text-blue-600 px-4 py-2 rounded hover:bg-blue-200"
              onClick={() => fileInputRef.current?.click()}
            >
              בחר קובץ
            </button>
          </>
        )}
        <input
          type="file"
          ref={fileInputRef}
          key={fileInputKey}
          className="hidden"
          accept="application/pdf"
          onChange={handleFileChange}
        />
      </div>
    </div>
  );
};

export default FileUploadArea;